import type { SeedingContentChannel } from '@musinsa/services-curator';

const IcSnsInstagram = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Instagram"
  >
    <title>Instagram</title>
    <g clipPath="url(#clip0_634_84590)">
      <mask
        id="mask0_634_84590"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="12"
        height="12"
      >
        <path
          d="M7 2.49086C8.46859 2.49086 8.64254 2.49636 9.22254 2.52285C9.75884 2.54731 10.0501 2.63681 10.2438 2.71219C10.5007 2.81203 10.6838 2.93106 10.8763 3.12353C11.0687 3.316 11.188 3.49918 11.2876 3.75598C11.363 3.94977 11.4525 4.24098 11.477 4.77729C11.5034 5.35729 11.509 5.53119 11.509 6.99982C11.509 8.46846 11.5035 8.64232 11.477 9.22232C11.4525 9.75862 11.363 10.0498 11.2876 10.2436C11.1878 10.5005 11.0688 10.6836 10.8763 10.8761C10.6838 11.0685 10.5006 11.1878 10.2438 11.2874C10.0501 11.3628 9.75884 11.4523 9.22254 11.4768C8.64258 11.5032 8.46864 11.5087 7 11.5087C5.53136 11.5087 5.35751 11.5032 4.77751 11.4768C4.2412 11.4523 3.94999 11.3628 3.7562 11.2874C3.49936 11.1875 3.31622 11.0685 3.12375 10.8761C2.93132 10.6836 2.81203 10.5004 2.71241 10.2436C2.63699 10.0498 2.54753 9.75862 2.52307 9.22232C2.49662 8.64236 2.49108 8.46842 2.49108 6.99982C2.49108 5.53123 2.49658 5.35733 2.52307 4.77729C2.54753 4.24098 2.63703 3.94977 2.71241 3.75598C2.81225 3.49914 2.93128 3.316 3.12375 3.12353C3.31622 2.9311 3.4994 2.81181 3.7562 2.71219C3.94999 2.63681 4.2412 2.54731 4.77751 2.52285C5.35746 2.49662 5.53141 2.49086 7 2.49086ZM7 1.5C5.50628 1.5 5.31892 1.50638 4.73231 1.53305C4.14681 1.55971 3.74714 1.65278 3.39731 1.78875C3.03557 1.92938 2.72895 2.11745 2.42318 2.42318C2.11745 2.72895 1.9292 3.03557 1.78875 3.39731C1.65273 3.74718 1.55971 4.14703 1.53305 4.73231C1.50638 5.31896 1.5 5.50632 1.5 7C1.5 8.49368 1.50638 8.68108 1.53305 9.26768C1.55971 9.85319 1.65278 10.2529 1.78875 10.6027C1.92938 10.9644 2.11745 11.271 2.42318 11.5768C2.72895 11.8826 3.03579 12.0706 3.39731 12.2113C3.74718 12.3473 4.14703 12.4403 4.73231 12.467C5.31892 12.4936 5.50628 12.5 7 12.5C8.49372 12.5 8.68108 12.4936 9.26768 12.467C9.85319 12.4403 10.2529 12.3472 10.6027 12.2113C10.9644 12.0706 11.271 11.8826 11.5768 11.5768C11.8826 11.271 12.0706 10.9642 12.2113 10.6027C12.3473 10.2529 12.4403 9.85297 12.467 9.26768C12.4936 8.68108 12.5 8.49372 12.5 7C12.5 5.50628 12.4936 5.31892 12.467 4.73231C12.4403 4.14681 12.3472 3.74714 12.2113 3.39731C12.0706 3.03557 11.8826 2.72895 11.5768 2.42318C11.271 2.11745 10.9642 1.92938 10.6027 1.78875C10.2529 1.65273 9.85297 1.55971 9.26768 1.53305C8.68113 1.50638 8.49372 1.5 7 1.5ZM7 4.17572C5.44014 4.17572 4.17572 5.44014 4.17572 7C4.17572 8.55986 5.44014 9.82432 7 9.82432C8.55986 9.82432 9.82432 8.55986 9.82432 7C9.82432 5.44014 8.55986 4.17572 7 4.17572ZM7 8.83346C5.98754 8.83346 5.16658 8.01277 5.16658 7.00004C5.16658 5.98732 5.98754 5.16662 7 5.16662C8.01246 5.16662 8.83342 5.98732 8.83342 7.00004C8.83342 8.01277 8.01246 8.83346 7 8.83346ZM9.93587 3.40418C9.57126 3.40418 9.27587 3.69957 9.27587 4.06418C9.27587 4.42878 9.57126 4.72422 9.93587 4.72422C10.3005 4.72422 10.5959 4.42878 10.5959 4.06418C10.5959 3.69957 10.3005 3.40418 9.93587 3.40418Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_634_84590)">
        <rect x="-1.6001" y="-1.59448" width="17.1611" height="17.1611" fill="#8A8A8A" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_634_84590">
        <rect width="12" height="12" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

const IcSnsYoutube = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="YouTube"
  >
    <title>YouTube</title>
    <path
      d="M7 3.15039C7.01257 3.15039 10.442 3.15035 11.2979 3.37988C11.7712 3.50668 12.1427 3.87925 12.2695 4.35254C12.4986 5.20988 12.5 7 12.5 7C12.5 7.01848 12.4983 8.79457 12.2695 9.64746C12.1427 10.1206 11.7711 10.4923 11.2979 10.6191C10.442 10.8487 7.01257 10.8496 7 10.8496C7 10.8496 3.55965 10.8491 2.70215 10.6191C2.22892 10.4924 1.85733 10.1206 1.73047 9.64746C1.50167 8.79457 1.50001 7.01848 1.5 7C1.5 7 1.50047 5.20988 1.73047 4.35254C1.85728 3.87924 2.22876 3.50666 2.70215 3.37988C3.55965 3.14993 7 3.15039 7 3.15039ZM5.90039 8.64941L8.75879 7L5.90039 5.35059V8.64941Z"
      fill="#8A8A8A"
    />
  </svg>
);

const IcSnsTiktok = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="TikTok"
  >
    <title>TikTok</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22913 2.00834C7.80031 2 8.36709 2.00416 8.93388 2C8.96877 2.6375 9.20857 3.28749 9.69687 3.73747C10.1852 4.19997 10.8741 4.41247 11.5455 4.4833V6.16245C10.9177 6.14161 10.2855 6.01661 9.71431 5.75829C9.46579 5.64995 9.23472 5.51245 9.008 5.37079C9.00364 6.58744 9.01237 7.8041 8.99929 9.01657C8.9644 9.5999 8.76384 10.1791 8.41069 10.6582C7.83953 11.4582 6.84983 11.979 5.83395 11.9957C5.21048 12.029 4.587 11.8665 4.05509 11.5665C3.17438 11.0707 2.55526 10.1624 2.46371 9.18741C2.45498 8.97907 2.45063 8.77075 2.45934 8.56659C2.53782 7.77492 2.94766 7.0166 3.58422 6.49994C4.30796 5.89995 5.31947 5.61245 6.26558 5.78329C6.2743 6.39995 6.24815 7.0166 6.24815 7.63326C5.8165 7.49992 5.31076 7.53742 4.93144 7.78742C4.65676 7.95826 4.44749 8.22075 4.33849 8.51659C4.24692 8.72909 4.27308 8.96241 4.27744 9.18741C4.38208 9.87074 5.07095 10.4457 5.80343 10.3832C6.29175 10.3791 6.75827 10.1082 7.01115 9.7124C7.09397 9.5749 7.18554 9.43324 7.18989 9.27074C7.2335 8.52491 7.21605 7.78326 7.22042 7.03744C7.22478 5.35829 7.21605 3.68331 7.22913 2.00834Z"
      fill="#8A8A8A"
    />
  </svg>
);

const IcSnsTwitter = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="X (Twitter)"
  >
    <title>X (Twitter)</title>
    <path
      d="M7.90379 6.2726L11.4404 2.25H10.6023L7.5315 5.74277L5.07885 2.25H2.25L5.95889 7.53168L2.25 11.75H3.08811L6.33097 8.06152L8.92115 11.75H11.75L7.90358 6.2726H7.90379ZM6.75589 7.57822L6.3801 7.05228L3.39009 2.86735H4.67737L7.09034 6.24472L7.46613 6.77066L10.6027 11.1607H9.31544L6.75589 7.57842V7.57822Z"
      fill="#8A8A8A"
    />
  </svg>
);

const CHANNEL_ICON: Partial<Record<SeedingContentChannel, () => JSX.Element>> = {
  INSTAGRAM: IcSnsInstagram,
  YOUTUBE: IcSnsYoutube,
  TIKTOK: IcSnsTiktok,
  TWITTER: IcSnsTwitter,
};

interface Props {
  channel: SeedingContentChannel;
}

export const SnsChannelIcon = ({ channel }: Props) => {
  const Icon = CHANNEL_ICON[channel];
  if (!Icon) return null;
  return <Icon />;
};
